<template>
  <button
    v-if="applicationUpdate.noticeTriggered && refreshSafety === 'safe'"
    type="button"
    class="application-update-bubble application-update-bubble-ready"
    @click="refreshPage"
  >
    <RefreshCw class="icon" />
    <span>{{ message }}</span>
  </button>
  <div
    v-else-if="applicationUpdate.noticeTriggered"
    class="application-update-bubble"
    :class="`application-update-bubble-${refreshSafety}`"
    role="status"
    aria-live="polite"
  >
    <AlertTriangle v-if="refreshSafety === 'conflict' || refreshSafety === 'blocked'" class="icon" />
    <RefreshCw v-else-if="refreshSafety === 'retrying'" class="icon application-update-icon-spin" />
    <LoaderCircle v-else class="icon application-update-icon-spin" />
    <span>{{ message }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AlertTriangle, LoaderCircle, RefreshCw } from 'lucide-vue-next';
import { useApplicationUpdateStore } from '../stores/applicationUpdate';
import { useWorkspaceStore } from '../stores/workspace';

const applicationUpdate = useApplicationUpdateStore();
const workspace = useWorkspaceStore();

const refreshSafety = computed(() => workspace.refreshSafety);
const message = computed(() => {
  switch (refreshSafety.value) {
    case 'conflict':
      return "Knowledge Base was updated. Can't refresh: a document has a save conflict. Resolve it first.";
    case 'blocked':
      return "Knowledge Base was updated. Can't refresh: document changes could not be saved. Retry the save first.";
    case 'retrying':
      return "Knowledge Base was updated. Can't refresh yet: saving failed and will be retried.";
    case 'pending':
      return "Knowledge Base was updated. Can't refresh yet: document changes have not finished saving.";
    default:
      return 'Knowledge Base was updated. Click to refresh.';
  }
});

function refreshPage(): void {
  if (workspace.refreshSafety !== 'safe') {
    return;
  }

  window.location.reload();
}
</script>
